<div class="title-row field-group mt-2" fxLayout="row" fxLayoutAlign="space-between center">
  <main class="title-simple-steps">
    <h1>
      {{ titleKey | translate }}
      <span class="text-[#6059a2]">*</span>
    </h1>
    <p *ngIf="descriptionKey" class="step-description my-2">{{ descriptionKey | translate }}</p>
  </main>
  <button *ngIf="showSkip" type="button" class="skip-btn" (click)="onSkip()">
    {{ "Skip" | translate }}
  </button>
</div>

<form
  class="sign-up-form"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="field-group all-days-row mb-3" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <div class="same-hours-wrapper mt-2" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <label class="ios-switch">
        <input
          type="checkbox"
          [(ngModel)]="selectAllDays"
          (change)="checkAllFromInput($event)"
          [ngModelOptions]="{ standalone: true }"
        />
        <span class="slider"></span>
      </label>
      <span class="same-hours-label">{{ "Same_Hours_For_All_Days" | translate }}</span>
    </div>
    <div
      *ngIf="selectAllDays"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="12px"
      class="all-days-times mt-2"
    >
      <input
        type="time"
        class="time-input"
        [(ngModel)]="startAll"
        (change)="onChangeAllTime('start', $event)"
        [ngModelOptions]="{ standalone: true }"
      />
      <span class="to-separator">{{ "TO" | translate }}</span>
      <input
        type="time"
        class="time-input"
        [(ngModel)]="endAll"
        (change)="onChangeAllTime('end', $event)"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>

  <div class="field-group days-list" *ngIf="!workingDaysLoading; else workingDaysSkeleton">
    <div
      *ngFor="let item of workingDays"
      class="day-row"
      [ngClass]="{ 'day-row-closed': !item.checked }"
      fxLayout="row wrap"
      fxLayoutAlign="start center"
      fxLayoutGap="16px"
    >
      <div class="bt-1 terms-checkbox-wrap">
        <mat-checkbox
          class="day-checkbox"
          color="primary"
          [(ngModel)]="item.checked"
          [ngModelOptions]="{ standalone: true }"
        >
          {{ dir == 'rtl' ? item.NameAr : item.NameEn | translate }}
        </mat-checkbox>
      </div>
      <div
        *ngIf="item.checked"
        class="day-times"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="12px"
      >
        <input
          type="time"
          class="time-input"
          [(ngModel)]="item.StartTime"
          [ngModelOptions]="{ standalone: true }"
        />
        <span class="to-separator">{{ "To" | translate }}</span>
        <input
          type="time"
          class="time-input"
          [(ngModel)]="item.FinishTime"
          [ngModelOptions]="{ standalone: true }"
        />
      </div>
      <span *ngIf="!item.checked" class="closed-label">{{ "Closed" | translate }}</span>
    </div>
  </div>

  <ng-template #workingDaysSkeleton>
    <div class="days-skeleton">
      <div class="day-row-skeleton" *ngFor="let i of [1,2,3,4,5,6,7]">
        <div class="skeleton-day-label"></div>
        <div class="skeleton-day-times"></div>
      </div>
    </div>
  </ng-template>

  <div
    class="actions-buttons"
    *ngIf="showActions"
    fxLayout="row"
    fxLayoutAlign="stretch center"
    fxLayoutGap="16px"
  >
    <button
      type="button"
      class="action-btn prev-btn d-flex align-items-center justify-content-center"
      fxFlex="1 1 0"
      (click)="onPrevious()"
    >
      {{ previousLabelKey | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="action-btn submit-btn"
      fxFlex="1 1 0"
      type="submit"
      [disabled]="loading"
    >
      {{ submitLabelKey | translate }}
      <span class="btn-spinner-icon" *ngIf="loading"></span>
    </button>
  </div>
</form>
